import { i18n } from '@lingui/core';

i18n.load('ja', {});
i18n.activate('ja');

export { i18n };
